export const GUEST_NAME_PLACEHOLDER = "$$GUEST_NAME$$";

export const applyGuestNamePlaceholder = (template, guestName) => {
  if (!template) return "";
  const name = guestName?.trim() ? guestName : "Guest";
  return template.split(GUEST_NAME_PLACEHOLDER).join(name);
};

const mapTemplateRow = (t) => ({
  ...t,
  id: String(t.id),
  isHotelLevel: !t.roomType,
  roomType: t.roomType || "-",
  roomTypes: t.roomType ? [t.roomType] : [],
  modifiedBy: t.modifiedBy || t.createdBy || "",
});

/**
 * Normalise GET /welcome-message-template?chainId=… (array, no pagination).
 */
export const normaliseTemplateList = (apiResponse) => {
  const list = Array.isArray(apiResponse) ? apiResponse : [];
  return list.map(mapTemplateRow);
};

/**
 * Normalise GET /welcome-message-template-search response for table display.
 */
export const normaliseTemplateSearchResponse = (apiResponse) => {
  const rawList = Array.isArray(apiResponse)
    ? apiResponse
    : apiResponse?.templates ?? apiResponse?.welcomeMessageResponse ?? [];
  return {
    welcomeMessageResponse: rawList.map(mapTemplateRow),
    totalPages: apiResponse?.totalPages || 1,
    totalRecords: apiResponse?.totalCount ?? rawList.length ?? 0,
    currentPageNo: apiResponse?.currentPageNo || 1,
    recordsPerPage: apiResponse?.recordsPerPage || 10,
  };
};

const roomTypeMatches = (a, b) =>
  a && b && String(a).toLowerCase() === String(b).toLowerCase();

/**
 * Resolve which welcome message template applies to a room.
 * Priority:
 * 1. Custom welcome message for that room number (from custom messages list)
 * 2. Default template matching the room's room type
 * 3. Hotel-level template (roomType null / empty)
 */
export const resolveWelcomeMessageForRoom = ({
  roomNo,
  roomType,
  templates = [],
  customMessages = [],
}) => {
  if (roomNo != null && roomNo !== "") {
    const custom = customMessages.find(
      (m) => String(m.roomNo) === String(roomNo) && m.welcomeMessage
    );
    if (custom?.welcomeMessage) {
      return custom.welcomeMessage;
    }
  }

  if (roomType) {
    const byRoomType = templates.find(
      (t) => t.roomType && roomTypeMatches(t.roomType, roomType)
    );
    if (byRoomType?.welcomeMessage) {
      return byRoomType.welcomeMessage;
    }
  }

  const hotelLevel = templates.find((t) => t.isHotelLevel || !t.roomType);
  if (hotelLevel?.welcomeMessage) {
    return hotelLevel.welcomeMessage;
  }

  return null;
};
